import MessageSender from '../sender'
import BaseMessage from '../message'

export default (id) => async () => {
  const msg = new BaseMessage()
  msg.setPath(`data/delete_talangan`)
  msg.setItem('id', id)

  const response = await new MessageSender().doGet(msg)
  return response
}
